/**
 * Generic form submission
 */
/* globals WEBROOT */

export default class FormSubmission {
    constructor() {
        // console.log('FormSubmission ctor');
        this.formData = {};
        this.parsleyOptions = {
            classHandler: (el) => el.$element.closest('.form-group'),
        };
        this.form = $('form.form_generic');
        this.formId = this.form.attr('id');
        this.endpoint = this.form.attr('data-endpoint');
        this.thanksMessage = $(`#${this.formId}-submitted`);
        this.initListeners();
        this.initOther();

        this.parsley = this.form.parsley(this.parsleyOptions);
        this.afterSubmit = false;
    }

    initListeners() {
        this.form.submit((e) => {
            e.preventDefault();
            e.stopPropagation();
            this.afterSubmit = true;

            if (!this.parsley.isValid()) return;

            // console.log('submit');
            const $form = $(e.currentTarget);
            $form.find('button[type="submit"]').attr('disabled', 'disabled');

            function getFormData(form) {
                const unindexedArray = form.serializeArray();
                const indexedArray = {};

                $.map(unindexedArray, (n) => {
                    if (indexedArray[n.name]) {
                        // convert to array and add item
                        if (!Array.isArray(indexedArray[n.name])) {
                            indexedArray[n.name] = [indexedArray[n.name]];
                        }
                        indexedArray[n.name].push(n.value);
                    } else {
                        // add new item
                        indexedArray[n.name] = n.value;
                    }
                });

                return indexedArray;
            }

            this.formData = getFormData(this.form);

            fetch(`${WEBROOT}${this.endpoint}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    credentials: 'same-origin',
                },
                body: JSON.stringify(this.formData),
            })
                .then((response) => response.json())
                .then((data) => {
                    window.formResponse = data;
                    if (data.status === 0) {
                        // console.log('submit success');
                        // Show thank you message
                        if ($(`#${this.formId}-page`).length) {
                            $(`#${this.formId}-page`).hide();
                        }
                        this.form.hide();
                        this.thanksMessage.fadeIn(200);
                        $('html, body').animate(
                            {
                                scrollTop: this.thanksMessage.offset().top - 200,
                            },
                            200
                        );
                    } else {
                        // console.log('submit failed');
                        // console.log(data);
                        const errorKey = Object.keys(data.data.errors)[0];
                        const { errorMessage } = data.data.errors[errorKey];
                        $('.error-container').show().find('.error-message').text(errorMessage);
                        // reenable submit
                        $form.find('button[type="submit"]').removeAttr('disabled');
                    }
                })
                .catch((error) => {
                    console.log(error);
                    // console.log('submit failed');
                    // reenable submit
                    $form.find('button[type="submit"]').removeAttr('disabled');
                });
        });
    }

    initOther() {
        this.form.find('select').each((i, s) => {
            const select = $(s);
            const selectIdMatch = select.attr('id').match(/meta\[([^\]]*)\]/);
            if (!selectIdMatch) return;

            const selectId = selectIdMatch[1];

            const otherOption = select.find('option[value=other]');
            const otherInput = this.form.find(`input#meta\\[${selectId}_other\\]`);
            const otherForm = otherInput.closest('.form-element');
            if (otherOption.length === 0 || otherInput.length === 0 || otherForm.length === 0) return;

            const otherLabel = otherForm.find('label');
            otherLabel.text(`${otherLabel.text()}*`);

            otherForm.hide();
            select.change(() => {
                if (this.afterSubmit) {
                    select.parsley().validate();
                }
                const val = select.find('option:checked').val();

                if (val === 'other') {
                    otherInput.attr('required', true);
                    otherInput.addClass('required');
                    otherForm.fadeIn(200);
                } else {
                    otherInput.removeAttr('required');
                    otherInput.removeClass('required');
                    otherForm.fadeOut(200);
                }
            });
        });
    }
}
